import { render, staticRenderFns } from "./FrequenciaMensalAEEouACP.vue?vue&type=template&id=7206be06&scoped=true&"
import script from "./FrequenciaMensalAEEouACP.vue?vue&type=script&lang=js&"
export * from "./FrequenciaMensalAEEouACP.vue?vue&type=script&lang=js&"
import style0 from "./FrequenciaMensalAEEouACP.vue?vue&type=style&index=0&id=7206be06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7206be06",
  null
  
)

export default component.exports